import { Component } from '@angular/core';

/** The `shipping` partial: the three promises under the home page. */
@Component({
  selector: 'shipping',
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Shipping -->
    <section class="shipping bgwhite p-t-62 p-b-46">
      <div class="flex-w p-l-15 p-r-15">
        <div class="flex-col-c w-size5 p-l-15 p-r-15 p-t-16 p-b-15 respon1">
          <h4 class="m-text12 t-center">
            Швидка доставка
          </h4>

          <span class="s-text11 t-center">
            Замовлення відправляємо на вибране Вами відділення
            не пізніше наступного дня
          </span>
        </div>

        <div class="flex-col-c w-size5 p-l-15 p-r-15 p-t-16 p-b-15 bo2 respon2">
          <h4 class="m-text12 t-center">
            Без обов’язкових передоплат
          </h4>

          <span class="s-text11 t-center">
            Всі товари наш магазин висилає накладним платежем. Оплата по фатку отримання
          </span>
        </div>

        <div class="flex-col-c w-size5 p-l-15 p-r-15 p-t-16 p-b-15 respon1">
          <h4 class="m-text12 t-center">
            Гарантія якості
          </h4>

          <span class="s-text11 t-center">
            Ви маєте можливість переконатись у якості товару у пункті видачі перед оплатою
          </span>
        </div>
      </div>
    </section>
    `
})
export class ShippingComponent {
}
